import Emitter from "./Emitter";
import {constants} from "../../constants";

export default class ResumeGame extends Emitter {
    constructor(gb) {
        super(gb);
    }

    SLINGO_handler() {
        this.emitGame({ event: "playResumed" });
    }

    GREENTUBE_handler() {
       return
    }

    RELAX_handler() {
        this.emitGame({ rgMessage: "oprg_GameResume"});
    }

    PNG_handler() {
        this.emitGame({ messageType: "request", request: "gameEnable" });
    }

    MGS_handler() {
        this.emitGame("ReStartGamePlay");
    }

    THUNDER_handler() {
        this.emitGame({ eventid: "resumegame" });
    }

    EDICT_handler() {
        this.emitGame("resumeGame");
    }

    NLC_NLC_handler() {
        if (this.gb.nlcExtendRef) {
            this.gb.nlcExtendRef.call("resume");
        } else {
            this.emitGame("resume");
        }
    }

    NETE_BLUEOCEAN_handler() {
        this.gb.netEntExtendRef.call("resumeAutoplay", [], function() { }, function(e) { });
    }

    NETE_NETE_handler() {
        this.gb.netEntExtendRef.call("resumeAutoplay", [], function() { }, function(e) { });
    }

    STK_handler() {
        if (gcw) {
            gcw.triggerThirdPartyEvent("UNPAUSE")
        }
    }

    // GSYSB_handler() {
    //     this.emitGame({ event: "playResumed"});
    // }

    // GSYSP_handler() {
    //     this.emitGame({ event: "playResumed"});
    // }
    BGS_handler() {
        this.emitGame({ event: "doGameResume"});
    }

    RGU_handler() {
        this.emitGame({ event: "doGameResume"});
    }

    RAW_handler() {
        this.emitGame({ event: "doGameResume"});
    }

    HB_handler() {
        this.emitGame({ event: "doGameResume"});
    }

    WD_handler() {
        this.emitGame({method:"WGEAPI.game.resumeGamePlay"})
    }

    QS_handler() {
        this.emitGame({ rgMessage: "oprg_GameResume"});
    }

    // SH_handler() {
    //     this.emitGame({name: 'game', value: 'resume'})
    // }

    HI5_handler() {
        window.postMessage({cmd:"hi5_pause",value:false},"*");
    }

    HKS_handler() {
        this.emitGame({ actionType: "enableGame" });
    }

    SYN_handler() {
        this.emitGame({event: "p2g.gamePlayResume"});
    }

    KAJ_handler() {
        this.emitGame({'method': 'gel.gamePlay.resume'});
    }

    ISOFT_handler() {
        this.emitGame('UNBLOCK_BETS');
    }

    RST_handler() {
        this.emitGame(JSON.stringify({"event": "playResumed"}))
    }

    PT_handler() {
        this.emitGame(JSON.stringify({
            "_type": "ucip.pause.w2gPauseCommand",
            "pause": false
        }))
    }

    YGG_handler() {
        this.emitGame({event:"game/resume"})
    }

    HBN_handler() {
        this.emitGame({type: "pause", pause: false})
        this.emitGame({event: "playResumed"})
    }

    BFG_handler() {
        this.emitGame({ "bf:request_action": "resume" });
    }

    ENDOR_handler() {
        this.emitGame({ messageId: "unblockGame" });
    }

    SPN_handler() {
        this.emitGame({type: "resumeGame"})
    }

    _default() {
        // if (this.gb.walletProtocol === constants.PLAYTECH && this.gb.gameProviderCode === 'GAM' && this.gb.ptResFeat && this.gb.ptResFeat.includes('displaystatus')) {
        //     this.gb.emitters.emit.web.customMsg(JSON.stringify({
        //         "_type": "ucip.displaystatus.g2wUiStateNotification",
        //         "busy": false
        //     }))
        // }

        this.emitGame({ wpgaction: "doGameResume" });
    }
}
